import { TnplChargeStatus, TnplContractStatus } from "../../../tnpl-contract";
import { SchemaInstance, defineSchema } from "../../type-system/schema";
import {
  baseTrackingSchema,
  exampleBaseTrackingSchemaInstance,
} from "./base-tracking";

export const tnplTrackingSchema = defineSchema({
  fields: {
    ...baseTrackingSchema.fields,
    tnplContractId: {
      dataType: "Text",
      documentation: "The unique identifier for the TNPL contract",
      hideFromInsertionModal: true,
    },
    tnplContractName: {
      dataType: "Text",
      documentation: "The name/title of the TNPL contract",
    },
    tnplContractStatus: {
      dataType: "Enum",
      values: Object.values(TnplContractStatus),
      documentation: "The current status of the TNPL contract",
    },
    trialPeriodEnd: {
      dataType: "Maybe Date",
      documentation: "The date when the trial period ends",
    },
    chargeDate: {
      dataType: "Maybe Date",
      documentation: "The date when the customer will be charged",
    },
    chargeAmount: {
      dataType: "Maybe Number",
      documentation: "The amount to be charged to the customer",
    },
    initialFullAmountCharge: {
      dataType: "Maybe Number",
      documentation: "The initial full amount charge for the TNPL contract",
    },
    chargeStatus: {
      dataType: "Enum",
      values: Object.values(TnplChargeStatus),
      documentation: "The current status of the charge process",
    },
    daysRemainingInTrial: {
      dataType: "Maybe Number",
      documentation: "Number of days remaining in the trial period",
    },
    returnDeadline: {
      dataType: "Maybe Date",
      documentation: "The deadline for returning trial items",
    },
    createTnplReturnLink: {
      dataType: "Maybe Url",
      documentation: "Link to create a TNPL return",
    },
    viewOrdersLink: {
      dataType: "Url",
      documentation: "Link to view orders in the customer portal",
    },
    keepAllItemsLink: {
      dataType: "Url",
      documentation: "Link to keep all items and complete the purchase",
    },
  },
});

export const exampleTnplTrackingSchemaInstance: SchemaInstance<
  typeof tnplTrackingSchema
> = {
  ...exampleBaseTrackingSchemaInstance,
  tnplContractId: "65b81f41da22f4000718b34f",
  tnplContractName: "Try First - 7 Day Trial",
  tnplContractStatus: TnplContractStatus.TRIAL_ACTIVE,
  trialPeriodEnd: Temporal.Now.instant()
    .add({ hours: 7 * 24 })
    .toZonedDateTimeISO("UTC")
    .toPlainDate(),
  chargeDate: Temporal.Now.instant()
    .add({ hours: 8 * 24 })
    .toZonedDateTimeISO("UTC")
    .toPlainDate(),
  chargeAmount: 99.99,
  initialFullAmountCharge: 199.99,
  chargeStatus: TnplChargeStatus.INITIATED_AUTHORIZE_PENDING,
  daysRemainingInTrial: 7,
  returnDeadline: Temporal.Now.instant()
    .add({ hours: 7 * 24 })
    .toZonedDateTimeISO("UTC")
    .toPlainDate(),
  createTnplReturnLink: "https://example.com/tnpl/return",
  viewOrdersLink: "https://example.com/orders",
  keepAllItemsLink: "https://example.com/tnpl/keep-all",
};
